import createBaseFetch from '../lib/Api';

const fetch = createBaseFetch({
  baseURL: process.env.VUE_APP_SYSTEM_SERVER_URL,
  timeout: 10000,
});

export default fetch;
